import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import MatchRatio from "../../../../components/MatchRatio";
import { NormalBoldText, BigHeadline } from "../../../../components/TextParts";
import InfoParts from "../molecules/InfoParts";
import { Box } from "@mui/system";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import CircleIconMatchRatioColor from "../molecules/CircleIconMatchRatioColor";
import { dashboardContext } from "../../Dashboard";
import { useLocalStorage } from "../../../../hooks/localStrage";

export default function NewMatching() {
  const navigate = useNavigate();
  const [, setCurrentPage] = useLocalStorage("currentPage");
  const { newMatchingList = [] } = useContext(dashboardContext);

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container>
      <BigHeadline text="新着マッチング" />
      <Grid item xs={12}>
        {newMatchingList.map((data, index) => {
          const personnels = data.personnels || {};
          const projects = data.projects || {};

          return (
            <Button
              key={data.id || index}
              variant="text"
              onClick={() => {
                setCurrentPage(process.env.REACT_APP_PERSONNELLIST_NUM);
                navigate("/personnelDetail", {
                  state: {
                    transitionSorce: "dashboard",
                    personnelId: data.personnel_id,
                    projectId: projects.id,
                  },
                });
              }}
              sx={{
                p: 0,
                m: 0,
                width: "100%",
                bgcolor: "#fff",
                color: "#1f1f1f",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#f9f9f9",
                },
              }}
            >
              <Box
                sx={{
                  p: "20px",
                  width: "100%",
                  display: "flex",
                  borderBottom: 1.5,
                  borderColor: "#eee",
                  textAlign: "left",
                }}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        mb: "20px",
                        flexDirection: { xs: "column", sm: "row" },
                        flexGrow: 1,
                      }}
                    >
                      <Box sx={{ display: "flex", gap: "10px" }}>
                        <CircleIconMatchRatioColor ratio={data.match_ratio} />
                        <div style={{ whiteSpace: "nowrap" }}>
                          <NormalBoldText
                            text={personnels.mail_received?.substring(0, 10) || ""}
                            sx={{ mr: "10px" }}
                          />
                        </div>
                        <NormalBoldText text={personnels.id || ""} />
                      </Box>
                      <NormalBoldText text={projects.mail_subject || ""} />
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <MatchRatio
                        ratio={data.match_ratio}
                        width="70px"
                        mainFontSize="25px"
                        subFontSize="10px"
                      />
                    </Box>
                  </Box>
                  <Grid container spacing={isSmall ? 0 : 2}>
                    <Grid item xs={12} sm={6}>
                      <InfoParts
                        head="商流の程度"
                        info={`${personnels.belonging_flag_label || ""} / ${personnels.employment_status_label || ""}`}
                      />
                      <InfoParts
                        head="単価"
                        info={`${Number(personnels.cost_high || 0).toLocaleString()}万円`}
                      />
                      <InfoParts head="年齢" info={`${personnels.age || "-"}歳`} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InfoParts
                        head="稼働開始予定"
                        info={projects.actual_work || "未定"}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    display: { xs: "none", sm: "block" },
                    mr: 0,
                    ml: "auto",
                    pl: { xs: "20px", sm: "40px" },
                  }}
                >
                  <MatchRatio
                    ratio={data.match_ratio}
                    width="100px"
                    mainFontSize="40px"
                    subFontSize="10px"
                  />
                </Box>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Grid>
  );
}